import React from "react";
import { Row, Col } from "react-bootstrap";
import amexIcon from "../../../../../../../img/card_amex.svg";
import visaIcon from "../../../../../../../img/card_visa.svg";
import mastercardIcon from "../../../../../../../img/card_mastercard.svg";
import { FadeButton, SolidButton } from "../../../../../../library/button";
import { useDispatch, useSelector } from "react-redux";
import {
  changeCompanyModal,
  setActivePaymentMethod,
} from "../../../../../../../redux/actions/company";
import "./style.scss";
import { channel } from "redux-saga";

const Index = ({ details }) => {
  const dispatch = useDispatch();

  const defaultMethod = useSelector(
    (state) => state.company.paymentMethods?.default
  );

  const renderDisplayIcon = (type) => {
    switch (type) {
      case "email":
        return <i class="fad fa-at"></i>;
      default:
        return <i class="fad fa-exclamation-triangle"></i>;
    }
  };

  const renderCredits = () => {
    return `100 e-poster sendt`;
  };

  const renderCreditsUsed = () => {
    return (0 / 100) * 100;
  };

  const clickRemoveMethod = () => {
    dispatch(changeCompanyModal({ deleteEmailChannel: true }));
    /*
        dispatch(setActivePaymentMethod(details))
        dispatch(changeCompanyModal({removePaymentMethod: true}))
        */
  };

  const clickUpdateMethod = () => {
    /*
        dispatch(setActivePaymentMethod(details))
        dispatch(changeCompanyModal({updatePaymentMethod: true}))
        */
  };

  return (
    <Col md={12} className="single-channel-col">
      <div className="inner-single-channel-container">
        <div className="name-container">
          <h4 className="channel-name">{details.name}</h4>
          {/*defaultMethod === details.id && <FadeButton color="green" size="xs" title="Primærvalg"/>*/}
        </div>
        <Row className="details-row">
          <Col className="thumbnail-col my-auto">
            <div className="thumbnail-container">
              <span className="thumbnail-icon">
                {renderDisplayIcon(details.type)}
              </span>
            </div>
          </Col>
          <Col className="info-col my-auto">
            <h4 className="channel-type-ending">{details.username}</h4>
            <p className="channel-expiry-date">
              Kortet utløper {details.exp_month}/{details.exp_year}
            </p>
          </Col>
          <Col className="authori"></Col>
          <Col className="percentage-col">
            <div className="percentage-container">
              <div className="details-container">
                <span className="percentage-title">{renderCredits()}</span>
              </div>
              <div className="progress-container">
                <div className="progress" style={{ display: "flex" }}>
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: renderCreditsUsed() + "%" }}
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax={`50`}
                  >
                    50%
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col className="button-col my-auto text-right">
            <SolidButton
              onClick={() => clickRemoveMethod()}
              size="md"
              title="Konfigurer"
              spacing="right"
              color="gray"
            />
            <SolidButton
              onClick={() => clickRemoveMethod()}
              size="md"
              title="Slett"
              spacing="right"
              color="gray"
            />
          </Col>
        </Row>
      </div>
    </Col>
  );
};

export default Index;
